// Client-safe helpers only. Server-only ones (they read the request via next/headers) are imported by file, e.g.
// `@/shared/utils/getSiteOrigin`, so a client component importing this barrel never pulls them in.
export { buildOfferJsonLd } from './buildOfferJsonLd';
export { buildSiteJsonLd } from './buildSiteJsonLd';
export { calcTotalPrice } from './calcTotalPrice';
export { createTranslator } from './createTranslator';
export { decodeHtmlEntities } from './decodeHtmlEntities';
export { emailField } from './emailField';
export { getCartKey } from './getCartKey';
export { getCatalogItemPath } from './getCatalogItemPath';
export { getContacts } from './getContacts';
export { getCurrencySign } from './getCurrencySign';
export { getImagePath } from './getImagePath';
export { getImageUrl } from './getImageUrl';
export { getOfferPath } from './getOfferPath';
export { hasAuthCookie } from './hasAuthCookie';
export { hasSocialContacts } from './hasSocialContacts';
export { isAnalyticsGoal } from './isAnalyticsGoal';
export { isDialCodeOnly } from './isDialCodeOnly';
export { isExternalLink } from './isExternalLink';
export { isProductionEnv } from './isProductionEnv';
export { isValidTimeZone } from './isValidTimeZone';
export { localizeStorageUrls } from './localizeStorageUrls';
export type { ParsedOfferSegment } from './parseOfferSegment';
export { parseOfferSegment } from './parseOfferSegment';
export { passwordField } from './passwordField';
export { persistAuthTokens } from './persistAuthTokens';
export { phoneField } from './phoneField';
export { reachGoal } from './reachGoal';
export { readAuthTokens } from './readAuthTokens';
export { sanitizeHtml } from './sanitizeHtml';
export { sendGaEvent } from './sendGaEvent';
export { stringMax } from './stringMax';
export { stringMin } from './stringMin';
export { stringMinMax } from './stringMinMax';
export { stringRequired } from './stringRequired';
export { toPlainText } from './toPlainText';
export { translateAuthMessage } from './translateAuthMessage';
export { withAlpha } from './withAlpha';
export { withNoDigits } from './withNoDigits';
